import React from 'react';
import { BarcodeOutlined, InfoCircleOutlined, SettingOutlined } from '@ant-design/icons';
import { SectionIcon } from '../SectionIcon';

const ICONS = { identification: BarcodeOutlined, engine: SettingOutlined, general: InfoCircleOutlined };

// Vehicle identification across the column, then Engine & transmission and General specifications side by side
export const SpecsCards = ({ cards }) => {
    const wide = cards.filter(card => card.wide);
    const pair = cards.filter(card => !card.wide);
    const renderCard = card => (
        <section id={`specs-${card.key}`} className="card" aria-labelledby={`specs-${card.key}-title`} key={card.key}>
            <h2 id={`specs-${card.key}-title`} className="h2">
                {ICONS[card.key] && <SectionIcon icon={ICONS[card.key]} />}
                {card.title}
            </h2>
            <dl className={`kv-list${card.wide ? ' kv-cols' : ''}`}>
                {card.rows.map(row => (
                    <div className="kv" key={row.key || row.label}>
                        <dt>{row.label}</dt>
                        <dd className={row.mono ? 'mono' : undefined}>
                            {row.value}
                            {row.sub && <span className="sub"> {row.sub}</span>}
                        </dd>
                    </div>
                ))}
            </dl>
        </section>
    );

    return (
        <>
            {wide.map(renderCard)}
            {pair.length > 0 && <div className="two">{pair.map(renderCard)}</div>}
        </>
    );
};
